import { EntityType } from '../components/DTStudio/interfaces'

export const getNoHideEntityList = (list: EntityType[]): EntityType[] => {
    let updatedList: EntityType[] = []
    for (const i of list) {
        if (i.isHidden) {
            if (i.subEntityTypes?.length) {
                const subList = getNoHideEntityList(i.subEntityTypes)
                updatedList = [...updatedList, ...subList]
            }
        } else {
            updatedList = [...updatedList, i]
        }
    }
    return updatedList
}
